import moment from "moment"
import { Col, Modal, Row } from "react-bootstrap"
import { FlagFill } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import Flag from "react-world-flags"
import { GLOBAL_CONSTANTS } from "../../constants/constants"

const ViewPromoCodesModal = ({
    show,
    handleClose,
    data
}: {
    show: any
    handleClose: () => void
    data: Record<string, any>
}) => {
    const { t } = useTranslation()
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t(data?.coupon_type) + " " + t("Promo_Codes")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="my-3">
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Code_Name")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.name}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Code")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.code}
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Discount_Type")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.discount_type === "percent" ? (
                            <span className="percent_discount">{t("Percentage")}</span>
                        ) : (
                            <span className="flat_discount">{t("Flat_Discount")}</span>
                        )}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Value")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.discount_type === "flat"
                            ? data?.discount + " " + t(GLOBAL_CONSTANTS.CURRENCY_VAL)
                            : data?.discount + " " + t("%")}
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("User_Type")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.is_open === 1 ? t("All") : t("Single_Multiple")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Country")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="w-25">
                            {data?.country_code ? (
                                <Flag code={data?.country_code} />
                            ) : (
                                <FlagFill color="#000" size={20} />
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Start_Date")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.start_date ? moment(data?.start_date).format("DD MMM yyyy") : ""}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} className="label">
                        {t("Expiry_Date")}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3}>
                        {data?.expiry_date ? moment(data?.expiry_date).format("DD MMM yyyy") : ""}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    )
}

export default ViewPromoCodesModal
